import { render } from "./CasinoLiveComponentSidebar.vue?vue&type=template&id=5a4ed3fa&scoped=true&ts=true"
import script from "./CasinoLiveComponentSidebar.vue?vue&type=script&lang=ts"
export * from "./CasinoLiveComponentSidebar.vue?vue&type=script&lang=ts"

import "./CasinoLiveComponentSidebar.vue?vue&type=style&index=0&id=5a4ed3fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4ed3fa"]])

export default __exports__